var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClientServices from "../..";
function getAuthenticatedUser(token, userId) {
    return __awaiter(this, void 0, void 0, function* () {
        if (token && userId) {
            const url = "/useradmin/admin";
            try {
                const response = yield apiClientServices.get(`${url}/me/${userId}`);
                if (response.data) {
                    return {
                        data: response.data.result,
                        status: response.data.status,
                        message: response.data.message,
                    };
                }
                else {
                    throw new Error(`Failed to fetch user profile: ${response}`);
                }
            }
            catch (error) {
                return {
                    data: undefined,
                    error: error,
                };
            }
        }
        else {
            return {
                notFound: "Something went wrong",
            };
        }
    });
}
const authService = {
    getAuthenticatedUser,
};
export default authService;
